/* @flow */

export const constants = {
  API_ERROR: 'Errors/API_ERROR',
};

export type ErrorType = {
  data: {
    message: string,
    status: string,
    timestamp: number,
  },
  type: 'Errors/API_ERROR' | '',
};

export type StateType = Array<ErrorType>;
export type PayloadType = { message: string, status: string };
export type ActionType = { payload: PayloadType, type: 'Errors/API_ERROR' | '' };

export const actions = {
  apiError: (payload: PayloadType): ActionType => ({ type: constants.API_ERROR, payload }),
};

export default { constants, actions };



// WEBPACK FOOTER //
// ./src/actions/errors.js